
export const FETCH_OWNERS = 'FETCH_OWNERS'
export const FETCH_OWNERS_SUCCESS = 'FETCH_OWNERS_SUCCESS'
export const FETCH_OWNERS_FAILURE = 'FETCH_OWNERS_FAILURE'

export const fetchOwners = (search) => ({
    type: FETCH_OWNERS,
    payload: search
})

export const fetchOwnersSuccess = (owners) => ({
    type: FETCH_OWNERS_SUCCESS,
    payload: owners
})

export const fetchOwnersFailed = (message) => ({
    type: FETCH_OWNERS_FAILURE,
    payload: message
})
